"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedEdgeTypeMatrix = exports.edgeTypeMatrix = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const ModelTypes_1 = require("../../types/ModelTypes");
const helpers_1 = require("./helpers");
// import { getGroupToTypeEdgeTypeMatrixEntry } from './helpers';
/**
 * 2024 changed keys to edgeTypes
 * customer_has_Region => customer_has_region
 * property_has_Area => property_has_area
 * property_has_Place => property_has_place
 * region_has_Subregion => region_has_region
 * area_has_Entity => area_has_entity
 * place_has_Entity => place_has_entity
 */
// this needs to conform to EdgeTypeMatrixType but is not typed as such to allow direct access to sub attributes
/**
 * Canonical definition of the edge types between classes in the datamodel
 * The third level key MUST be the same as its corresponding edgeTypeId so that the construct can be tested in file:///./../../../test/Contructs/EdgeTypeMatrix/getEdgeTypeIds.test.ts
 */
exports.edgeTypeMatrix = {
    System: {
        LambdaFunction: {
            system_has_lambdaFunction: {
                edgeTypeId: 'system_has_lambdaFunction',
                labels: {
                    out: 'system has lambdaFunction',
                    in: 'is part of System',
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
            },
        },
        LoRaWANApplicationServer: {
            system_has_LoRaWANApplicationServer: {
                edgeTypeId: 'system_has_LoRaWANApplicationServer',
                labels: {
                    out: 'system has ApplicationServer',
                    in: 'is part of System',
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
            },
        },
    },
    LoRaWANApplicationServer: {
        Device: {
            networkApplicatonServer_has_device: {
                edgeTypeId: 'networkApplicatonServer_has_device',
                labels: {
                    out: 'Device',
                    in: 'is device in ApplicationServer',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
    },
    Customer: {
        Ruleset: {
            customerHasRuleset: {
                cardinality: undefined,
                edgeTypeId: 'customerHasRuleset',
                labels: {
                    in: 'has ruleset',
                    out: 'ruleset belonging to this customer',
                },
                edgeAttributes: {},
            },
        },
        EntityNetwork: {
            customer_has_entity_network: {
                edgeTypeId: 'customer_has_entity_network',
                labels: {
                    out: 'has entity network',
                    in: 'is entity network for customer',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
                edgeAttributes: {},
            },
        },
        EntityProgrammeSet: {
            customer_has_entity_programme_set: {
                cardinality: {
                    out: null,
                    in: 1,
                },
                edgeTypeId: 'customer_has_entity_programme_set',
                labels: {
                    in: 'has programme set',
                    out: 'programme set is managed by customer',
                },
                edgeAttributes: {},
            },
        },
        EntityRollingProgramme: {
            customer_has_entity_rolling_programme: {
                cardinality: {
                    out: null,
                    in: 1,
                },
                edgeTypeId: 'customer_has_entity_rolling_programme',
                labels: {
                    in: 'has rolling programme',
                    out: 'rolling programme is managed by customer',
                },
                edgeAttributes: {},
            },
        },
        OnDemandProgramme: {
            customer_has_on_demand_programme: {
                cardinality: {
                    out: null,
                    in: 1,
                },
                edgeTypeId: 'customer_has_on_demand_programme',
                labels: {
                    in: 'has on demand programme',
                    out: 'on demand programme is managed by customer',
                },
                edgeAttributes: {},
            },
        },
        Team: {
            customer_has_team: {
                edgeTypeId: 'customer_has_team',
                labels: {
                    out: 'has team',
                    in: 'is team under',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Customer: {
            customer_has_subCustomer_typeV: {
                edgeTypeId: 'customer_has_subCustomer_typeV',
                labels: {
                    out: 'has ' + ModelTypes_1.CustomerAccountType.V.valueOf(),
                    in: 'is sub customer of ' + ModelTypes_1.CustomerAccountType.V.valueOf(),
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
            },
            customer_has_subCustomer_typeX: {
                edgeTypeId: 'customer_has_subCustomer_typeX',
                labels: {
                    out: 'has ' + ModelTypes_1.CustomerAccountType.X.valueOf(),
                    in: 'is sub customer of ' + ModelTypes_1.CustomerAccountType.X.valueOf(),
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
            },
            customer_has_subCustomer_typeY: {
                edgeTypeId: 'customer_has_subCustomer_typeY',
                labels: {
                    out: 'has ' + ModelTypes_1.CustomerAccountType.Y.valueOf(),
                    in: 'is sub customer of ' + ModelTypes_1.CustomerAccountType.Y.valueOf(),
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
            },
            customer_has_subCustomer_typeZ: {
                edgeTypeId: 'customer_has_subCustomer_typeZ',
                labels: {
                    out: 'has ' + ModelTypes_1.CustomerAccountType.Z.valueOf(),
                    in: 'is sub customer of ' + ModelTypes_1.CustomerAccountType.Z.valueOf(),
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
            },
        },
        Device: {
            customer_device_inventory_includes: {
                edgeTypeId: 'customer_device_inventory_includes',
                labels: {
                    out: 'inventory includes',
                    in: 'is part of inventory for',
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
            },
            customer_has_been_allocated_device: {
                edgeTypeId: 'customer_has_been_allocated_device',
                labels: {
                    out: 'has been allocated device',
                    in: 'is allocated to customer',
                },
                edgeAttributes: {
                    assigningCustomerSk: {
                        key: 'assigningCustomerSk',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assigningCustomerName: {
                        key: 'assigningCustomerName',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assignedCustomerSk: {
                        key: 'assignedCustomerSk',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assignedCustomerName: {
                        key: 'assignedCustomerName',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assigningUserSk: {
                        key: 'assigningUserSk',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assigningUserName: {
                        key: 'assigningUserName',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assignmentDate: {
                        key: 'assignmentDate',
                        type: iotv_v3_types_1.AppValueTypes.DATE,
                    },
                    lastAssignedCustomer: {
                        key: 'lastAssignedCustomer',
                        type: iotv_v3_types_1.AppValueTypes.OBJECT,
                    },
                },
            },
        },
        Gateway: {
            customer_manages_gateway: {
                edgeTypeId: 'customer_manages_gateway',
                labels: {
                    out: 'manages gateway',
                    in: 'is managed by customer',
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
                edgeAttributes: {},
            },
            customer_has_been_allocated_gateways: {
                edgeTypeId: 'customer_has_been_allocated_gateways',
                labels: {
                    out: 'has been allocated gateway',
                    in: 'is allocated to customer',
                },
                edgeAttributes: {
                    assigningCustomerSk: {
                        key: 'assigningCustomerSk',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assigningCustomerName: {
                        key: 'assigningCustomerName',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assignedCustomerSk: {
                        key: 'assignedCustomerSk',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assignedCustomerName: {
                        key: 'assignedCustomerName',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assigningUserSk: {
                        key: 'assigningUserSk',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assigningUserName: {
                        key: 'assigningUserName',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                    assignmentDate: {
                        key: 'assignmentDate',
                        type: iotv_v3_types_1.AppValueTypes.DATE,
                    },
                    lastAssignedCustomer: {
                        key: 'lastAssignedCustomer',
                        type: iotv_v3_types_1.AppValueTypes.OBJECT,
                    },
                },
            },
        },
        User: {
            customer_has_users: {
                edgeTypeId: 'customer_has_users',
                labels: {
                    out: 'has users',
                    in: 'is user for customer',
                },
                cardinality: {
                    in: null,
                    out: null,
                },
                edgeAttributes: {
                    isAdminForCustomer: {
                        key: 'isAdminForCustomer',
                        type: iotv_v3_types_1.AppValueTypes.STRING,
                    },
                },
            },
        },
        Group: {
            customer_has_group: {
                edgeTypeId: (0, helpers_1.getObjectTypeHasGroupEdgeTypeId)('Customer'),
                labels: {
                    out: 'has group',
                    in: 'is group for customer',
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
                // We really REALLY need some sort of supported type thing here
            },
        },
        /* 2024 04 Customer doesn't have region. Customer can place some types eg Properties in Regions
        Region: {
          customer_has_region: {
            edgeTypeId: 'customer_has_region',
            labels: {
              out: 'has region',
              in: 'is region for customer',
            },
            cardinality: {
              in: null,
              out: null,
            },
          },
        },
        */
        Property: {
            customerHasProperty: {
                edgeTypeId: 'customerHasProperty',
                labels: {
                    in: 'has property',
                    out: 'property belonging to this customer',
                },
                edgeAttributes: {},
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Person: {
            customer_has_person: {
                edgeTypeId: 'customer_has_person',
                labels: {
                    in: 'is under customer',
                    out: 'has person',
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
            },
        },
    },
    EntityNetwork: {
        // Dummy entry - this is removed by @iotv/datamodel if Entity not present
        ...(0, helpers_1.getEntityNetworkToTypeEdgeTypeMatrixEntry)('Entity'),
    },
    EntityProgrammeSet: {
        EntityProgramme: {
            programme_set_has_programmes: {
                edgeTypeId: 'programme_set_has_programmes',
                labels: {
                    out: 'has programme',
                    in: 'is part of programme set',
                },
                cardinality: {
                    in: 1,
                    out: null,
                },
            },
        },
    },
    EntityProgramme: {
        ...(0, helpers_1.getEntityProgrammeToEntityEdgeTypeMatrixEntry)('Group'),
        Entity: {
            // Dummy entry - this is removed by @iotv/datamodel if Entity not present
            programme_schedules_entity: {
                edgeTypeId: 'programme_schedules_entity',
                labels: {
                    out: 'has schedule',
                    in: 'is scheduled by',
                },
                cardinality: {
                    in: null,
                    out: null,
                },
                edgeAttributes: {
                    schedule: {
                        key: 'schedule',
                        type: iotv_v3_types_1.AppValueTypes.OBJECT, // this needs to be UTCDayMaskPeriod but types cannot be used here
                    },
                },
            },
        },
    },
    EntityRollingProgramme: {
        Entity: {
            // Dummy entry - this is removed by @iotv/datamodel if Entity not present
            rolling_programme_schedules_entity: {
                edgeTypeId: 'rolling_programme_schedules_entity',
                labels: {
                    out: 'has schedule',
                    in: 'is scheduled by rolling programme',
                },
                cardinality: {
                    in: null,
                    out: null,
                },
                edgeAttributes: {
                    schedule: {
                        key: 'schedule',
                        type: iotv_v3_types_1.AppValueTypes.OBJECT, // this needs to be UTCDayMaskPeriod but types cannot be used here
                    },
                },
            },
        },
    },
    OnDemandProgramme: {
        Entity: {
            // Dummy entry - this is removed by @iotv/datamodel if Entity not present
            on_demand_programme_sequences_entity: {
                edgeTypeId: 'on_demand_programme_sequences_entity',
                labels: {
                    out: 'has schedule',
                    in: 'is scheduled by on demand programme',
                },
                cardinality: {
                    in: null,
                    out: null,
                },
                edgeAttributes: {
                    schedule: {
                        key: 'schedule',
                        type: iotv_v3_types_1.AppValueTypes.OBJECT, // this needs to be UTCDayMaskPeriod but types cannot be used here
                    },
                },
            },
        },
    },
    Incident: {
        AlertTrigger: {
            Incident_has_AlertTriggers: {
                edgeTypeId: 'Incident_has_AlertTriggers',
                labels: {
                    out: 'has trigger',
                    in: 'relates to incident',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
    },
    User: {
        NotificationSubscription: {
            User_has_NotificationSubscription: {
                edgeTypeId: 'User_has_NotificationSubscription',
                labels: {
                    out: 'has notification subscription',
                    in: 'is for user',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Notification: {
            User_has_Notification: {
                edgeTypeId: 'User_has_Notification',
                labels: {
                    out: 'has notification',
                    in: 'is for user',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        MobileDevice: {
            user_has_mobile_device: {
                edgeTypeId: 'user_has_mobile_device',
                labels: {
                    out: 'has mobile device',
                    in: 'belongs to user',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
    },
    Group: {
        Customer: {
            group_has_customer: {
                edgeTypeId: 'group_has_customer',
                labels: {
                    out: 'has customer',
                    in: 'is customer in group',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        User: {
            group_has_user: {
                edgeTypeId: 'group_has_user',
                labels: {
                    out: 'has user',
                    in: 'is user in group',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Device: {
            group_has_device: {
                edgeTypeId: 'group_has_device',
                labels: {
                    out: 'has device',
                    in: 'is device in group',
                },
                cardinality: {
                    out: null,
                    in: null,
                },
            },
        },
        Group: {
            group_has_subGroup: {
                edgeTypeId: 'group_has_subGroup',
                labels: {
                    out: 'has sub-group',
                    in: 'is sub group in group',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
            group_allows_group: {
                edgeTypeId: 'group_allows_group',
                labels: {
                    in: 'allows group',
                    out: 'is allowed by group',
                },
                cardinality: {
                    out: null,
                    in: null,
                },
            },
        },
        Gateway: {
            group_has_gateway: {
                edgeTypeId: 'group_has_gateway',
                labels: {
                    out: 'has gateway ',
                    in: 'is gateway in group',
                },
            },
        },
        Partner: {
            // Only for apex partner group
            group_has_partner: {
                edgeTypeId: 'group_has_partner',
                labels: {
                    out: 'has partner',
                    in: 'is group for partner',
                },
            },
        },
        // Pretty sure this isn't right
        //Property: {
        //  group_has_property: {
        //    edgeTypeId: 'group_has_property',
        //    labels: {
        //      out: 'has Property',
        //      in: 'is property in group',
        //    },
        //    cardinality: {
        //      out: null,
        //      in: null,
        //    },
        //  },
        //},
        // ...getGroupToTypeEdgeTypeMatrixEntry( 'Property'),
    },
    Property: {
        Area: {
            property_has_area: {
                edgeTypeId: 'property_has_area',
                labels: {
                    out: 'has area',
                    in: 'is area in property',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        // Field: {
        //   property_has_field: {
        //     edgeTypeId: 'property_has_field',
        //     labels: {
        //       out: 'has field',
        //       in: 'is field in property',
        //     },
        //     cardinality: {
        //       out: null,
        //       in: 1,
        //     },
        //   },
        // },
        Place: {
            property_has_place: {
                edgeTypeId: 'property_has_place',
                labels: {
                    out: 'has place',
                    in: 'is place in property',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Path: {
            property_has_path: {
                edgeTypeId: 'property_has_path',
                labels: {
                    out: 'has path',
                    in: 'is path in property',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Group: {
            property_has_group: {
                edgeTypeId: (0, helpers_1.getObjectTypeHasGroupEdgeTypeId)('Property'),
                labels: {
                    out: 'has group',
                    in: 'is group for property',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Gateway: {
            property_has_gateway: {
                edgeTypeId: 'property_has_gateway',
                labels: {
                    out: 'has gateway',
                    in: 'is gateway for property',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
    },
    Region: {
        Partner: {
            region_has_partner: {
                edgeTypeId: 'region_has_partner',
                labels: {
                    out: 'has partner',
                    in: 'is partner in region',
                },
            },
        },
        Property: {
            region_has_property: {
                edgeTypeId: 'region_has_property',
                labels: {
                    out: 'has property',
                    in: 'is property in region',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Region: {
            region_has_region: {
                edgeTypeId: 'region_has_region',
                labels: {
                    out: 'has region',
                    in: 'is region in region',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        // Area: {
        //   region_has_area: {
        //     edgeTypeId: 'region_has_area',
        //     labels: {
        //       out: 'has area',
        //       in: 'is area in region',
        //     },
        //   },
        // },
    },
    Area: {
        Area: {
            area_has_area: {
                edgeTypeId: 'area_has_area',
                labels: {
                    out: 'has area',
                    in: 'is area in area',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Place: {
            area_has_place: {
                edgeTypeId: 'area_has_place',
                labels: {
                    out: 'has place',
                    in: 'is place in area',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Path: {
            area_has_path: {
                edgeTypeId: 'area_has_path',
                labels: {
                    out: 'has path',
                    in: 'is path in area',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Group: {
            area_has_group: {
                edgeTypeId: (0, helpers_1.getObjectTypeHasGroupEdgeTypeId)('Area'),
                labels: {
                    out: 'has group',
                    in: 'is group for area',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
    },
    Place: {
        Group: {
            place_has_group: {
                edgeTypeId: (0, helpers_1.getObjectTypeHasGroupEdgeTypeId)('Place'),
                labels: {
                    out: 'has group',
                    in: 'is group for place',
                },
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        },
        Gateway: {
            place_has_gateway: {
                edgeTypeId: 'place_has_gateway',
                labels: {
                    out: 'has gateway',
                    in: 'is gateway at place',
                },
                cardinality: {
                    out: null,
                    in: null,
                },
            },
        },
    },
    Ruleset: {
        Group: {
            ruleset_has_group: {
                edgeTypeId: (0, helpers_1.getObjectTypeHasGroupEdgeTypeId)('Ruleset'),
                labels: {
                    out: 'has group',
                    in: 'is group in ruleset',
                },
                cardinality: {
                    out: null,
                    in: null,
                },
            },
        },
    },
    ScoreSet: {
        Group: {
            scoreset_has_group: {
                edgeTypeId: (0, helpers_1.getObjectTypeHasGroupEdgeTypeId)('ScoreSet'),
                labels: {
                    out: 'is scoreset for group',
                    in: 'uses scoreset',
                },
            },
        },
    },
    Team: {
        Person: {
            team_has_person: {
                edgeTypeId: 'team_has_person',
                labels: {
                    out: 'is team for person',
                    in: 'is person in team',
                },
            },
        },
        Group: {
            team_has_group: {
                edgeTypeId: (0, helpers_1.getObjectTypeHasGroupEdgeTypeId)('Team'),
                labels: {
                    out: 'is team for group',
                    in: 'is group managed by team',
                },
            },
        },
    },
    Partner: {
        Group: {
            partner_has_group: {
                edgeTypeId: (0, helpers_1.getObjectTypeHasGroupEdgeTypeId)('Partner'),
                labels: {
                    out: 'is partner for',
                    in: 'is group under partner',
                },
                //edgeAttributes: {
                //  // True if this edge links to visible entity group
                //  visibleEntityGroup: {
                //    key: 'visibleEntityGroup',
                //    type: AppValueTypes.BOOLEAN,
                //  },
                //},
            },
        },
    },
};
exports.typedEdgeTypeMatrix = exports.edgeTypeMatrix;
